/**
 * Role-based notification visibility (shared by AppRedux + geofencingNotificationService).
 * Aligns with map permissions: geofence vs vehicle vs tower, no vehicle bypass on geofence-only roles.
 */

function hasVehicleNotificationPermission(permissions, deviceType, deviceName) {
  if (permissions.viewVehicles === true) return true;
  if (!Array.isArray(permissions.viewVehicles) || permissions.viewVehicles.length === 0) {
    return false;
  }
  const allowed = permissions.viewVehicles.map((v) => String(v).toLowerCase());
  if (deviceType && allowed.some((a) => deviceType.includes(a) || a.includes(deviceType))) {
    return true;
  }
  if (deviceName && allowed.some((a) => deviceName.includes(a) || deviceName.includes(a.replace('_', ' ')))) {
    return true;
  }
  return false;
}

function hasGeofenceNotificationPermission(permissions, geofenceName) {
  const name = (geofenceName || '').toLowerCase();
  if (!name) return false;

  if (permissions.viewGeofences === true) return true;

  if (!Array.isArray(permissions.viewGeofences) || permissions.viewGeofences.length === 0) {
    return false;
  }

  return permissions.viewGeofences.some((t) => {
    const token = String(t).toLowerCase();
    if (token === 'all') return true;
    if (token === 'beach') {
      return name.startsWith('beach_') || name.includes('_beach_');
    }
    return name.includes(token);
  });
}

/**
 * @param {Object} notification - Firestore notification document fields
 * @param {Object} permissions - Role permissions from Redux / roles collection
 * @returns {boolean}
 */
export function hasNotificationPermission(notification, permissions) {
  if (!permissions || typeof permissions !== 'object') return false;

  const eventType = (notification.eventType || '').toLowerCase();
  const deviceType = (notification.deviceType || '').toLowerCase();
  const deviceName = (notification.deviceName || '').toLowerCase();
  const geofenceName = (notification.geofenceName || '').toLowerCase();
  const category = (notification.category || '').toLowerCase();

  if (eventType === 'offline' || category === 'offline_device') {
    return hasVehicleNotificationPermission(permissions, deviceType, deviceName);
  }

  // LG Band SOS: safety-critical, shown to every member who may see LG Bands on the map
  // (mirrors canViewAdafruitLocations: only an explicit viewAdafruit:false hides them).
  if (eventType === 'sos' || category === 'lg_band_sos') {
    return permissions.viewAdafruit !== false;
  }

  if (eventType === 'entry' || eventType === 'exit') {
    return hasGeofenceNotificationPermission(permissions, geofenceName);
  }

  if (notification.deviceType || notification.deviceId) {
    return hasVehicleNotificationPermission(permissions, deviceType, deviceName);
  }

  if (permissions.viewTowers === true) {
    if (geofenceName.includes('tower') || deviceName.includes('tower')) return true;
  }

  return hasGeofenceNotificationPermission(permissions, geofenceName);
}
